import forOwn from "mout/object/forOwn"
import queryString from "query-string"
const { find } = require("lodash")

import axios from "axios"
import { firebaseauth as auth } from "../../../mp-database/firebaseConfig"

export const getRequest = async (url, timeout = 30000) => {
  const user = auth.currentUser
  const token = user ? await user.getIdToken(false) : null

  const headers = token
    ? {
        Authorization: `Bearer ${token}`,
        "auth-provider": "firebase"
      }
    : {}

  return axios
    .get(url, {
      headers,
      timeout: timeout,
      responseType: "text"
    })
    .then(response => response.data)
    .catch(error => {
      if (error.code === "ECONNABORTED") {
        throw new Error("Request timeout")
      }
      throw error.response ? error.response.data : error.message
    })
}

export const postRequest = async (url, params = {}, timeout = 30000) => {
  const user = auth.currentUser
  const token = user ? await user.getIdToken(false) : null

  const headers = {
    "Content-Type": "application/x-www-form-urlencoded",
    "Access-Control-Allow-Origin": "*",
    ...(token
      ? {
          Authorization: `Bearer ${token}`,
          "auth-provider": "firebase"
        }
      : {})
  }

  return axios
    .post(url, queryString.stringify(params), {
      headers,
      timeout: timeout,
      responseType: "text"
    })
    .then(response => response.data)
    .catch(error => {
      if (error.code === "ECONNABORTED") {
        throw new Error("Request timeout")
      }
      throw error.response ? error.response.data : error.message
    })
}

export const stringTrim = (str = "") => str && str.replace(/\s+/g, " ").trim()

export const timestamper = () => {
  const date = new Date()
  return date.getTime()
}

export const slugify = (str = "") => {
  str = str.replace(/^\s+|\s+$/g, "") // trim
  str = str.toLowerCase()

  // remove accents, swap ñ for n, etc
  var from =
    "ÁÄÂÀÃÅČÇĆĎÉĚËÈÊẼĔȆĞÍÌÎÏİŇÑÓÖÒÔÕØŘŔŠŞŤÚŮÜÙÛÝŸŽáäâàãåčçćďéěëèêẽĕȇğíìîïıňñóöòôõøðřŕšşťúůüùûýÿžþÞĐđßÆa·/_,:;"
  var to =
    "AAAAAACCCDEEEEEEEEGIIIIINNOOOOOORRSSTUUUUUYYZaaaaaacccdeeeeeeeegiiiiinnooooooorrsstuuuuuyyzbBDdBAa------"
  for (var i = 0, l = from.length; i < l; i++) {
    str = str.replace(new RegExp(from.charAt(i), "g"), to.charAt(i))
  }

  str = str
    .replace(/[^a-z0-9 -]/g, "") // remove invalid chars
    .replace(/\s+/g, "-") // collapse whitespace and replace by -
    .replace(/-+/g, "-") // collapse dashes

  return str
}

export const getRandomString = (length, withTimeStamp) => {
  const alphabets = "1234567890abcdefghijklmnopqrstuvwxyz"
  let str = []
  for (let i = 0; i < length; i++) {
    str.push(alphabets[Math.round(Math.random() * (alphabets.length - 1))])
  }
  str = str.join("")
  return withTimeStamp ? `${new Date().getTime()}-${str}` : str
}

export const alphaNum = {
  0: "A",
  1: "B",
  2: "C",
  3: "D",
  4: "E",
  5: "F",
  6: "G"
}

export const arrayify = obj => {
  let newArray = []
  const objKeys = Object.keys(obj)
  objKeys.forEach(key => {
    newArray.push(obj[key])
  })
  return newArray
}

export const arrayifyWithKey = obj => {
  let newArray = []
  const objKeys = Object.keys(obj)
  objKeys.forEach(key => {
    newArray.push({
      ...obj[key],
      key
    })
  })
  return newArray
}

export const totalArray = array => {
  let sum = 0
  array.forEach(num => {
    sum += parseInt(num)
  })
  return sum
}

export const itemTypeDisplay = {
  "Multiple Choice": {
    passage: false,
    question: true,
    answers: true,
    videoFeedback: true,
    videoFeedbackThumbnail: true
  },
  "Multiple Choice Passage": {
    passage: true,
    question: true,
    answers: true,
    videoFeedback: true,
    videoFeedbackThumbnail: true
  },
  "Multiple Choice Passage Line Nums": {
    passage: true,
    question: true,
    answers: true,
    videoFeedback: true,
    videoFeedbackThumbnail: true
  },
  Passage: {
    passage: true
  },
  Content: {
    content: true,
    teacherGuidance: true,
    instructions: true,
    audioLink: true,
    audioTranscript: true,
    videoLink: true,
    videoTranscript: true
  },
  Directions: {
    instructions: true,
    audioLink: true,
    audioTranscript: true,
    videoLink: true,
    videoTranscript: true,
    teacherGuidance: true
  },
  Infographic: {
    imageLink: true,
    imageDescription: true,
    audioLink: true,
    audioTranscript: true,
    videoLink: true,
    videoTranscript: true,
    teacherGuidance: true
  },
  "Infographic Two Column": {
    imageLink: true,
    imageDescription: true,
    audioLink: true,
    audioTranscript: true,
    videoLink: true,
    videoTranscript: true,
    teacherGuidance: true
  },
  Slide: {
    imageLink: true,
    imageDescription: true,
    content: true,
    audioLink: true,
    audioTranscript: true,
    videoLink: true,
    videoTranscript: true,
    teacherGuidance: true
  }
}

export const removeProp = (obj, propKey) => {
  let outputObj = {}
  forOwn(obj, (val, key, o) => {
    key !== propKey ? (outputObj[key] = val) : null
  })
  return outputObj
}

export const isLicenseExpired = (role, assessmentSetId, userLicenses) => {
  if (role === "Student") {
    let val = find(userLicenses, function (val) {
      return val.licenseSet === assessmentSetId
    })
    if (val && Number(val.endDate) < Date.now()) {
      return true
    }
  }
  return false
}

export const getTrueProps = obj => {
  let output = []
  forOwn(obj, (val, key, o) => {
    if (val === true) {
      output.push(key)
    }
  })
  return output
}

export const getSchoolYear = () => {
  const date = new Date(Date.now())

  if (date.getMonth() > 6) {
    return {
      year: date.getFullYear(),
      timeStamp: date.getTime(),
      date: `${date.toDateString() + "-" + Number(date.getFullYear())}`
    }
  } else {
    return {
      year: date.getFullYear() - 1,
      timeStamp: date.getTime(),
      date: `${date.toDateString() + "-" + Number(date.getFullYear() - 1)}`
    }
  }
}

export const isSafari = () => {
  if (!window) return false
  if (!window.navigator) return false
  const ua = window.navigator.userAgent.toLowerCase()
  if (ua.indexOf("safari") != -1) {
    if (ua.indexOf("chrome") > -1) {
      return false
    } else {
      return true
    }
  }
}

export function sanitizeFilename(filename = "") {
  return filename.replace(/[^\d\w\s\._-]/g, "_")
}
